import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Product } from '../../../shared/interfaces/product';
import { Sale } from '../../../shared/interfaces/sale';
import { PaymentSuffixPipe } from '../../../shared/pipes/payment-suffix.pipe';
import { CalculatePaymentWithSalePipe } from '../../pipes/calculate-payment-with-sale.pipe';
import { ProductsService } from '../../../admin/services/products.service';
import { TermMileMonthPipe } from '../../pipes/term-mile-month.pipe';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-product-summary',
    standalone: true,
    imports: [CommonModule, CalculatePaymentWithSalePipe, PaymentSuffixPipe, TermMileMonthPipe],
    templateUrl: './product-summary.component.html',
    styleUrl: './product-summary.component.scss',
})
export class ProductSummaryComponent {
    @Input({ required: true }) public product!: Product;

    @Input({ required: true }) public sale!: Sale;

    public constructor(
        private readonly productsService: ProductsService,
    ) {
        //
    }

    public onProductDetails(): void {
        this.productsService.openProductDetails(
            this.product,
            this.sale,
            { showToggleButton: false },
        );
    }
}
